export { CheckTickIcon } from "./check-tick";
